import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IRegisterType } from '../interfaces/IRegisterType';

export async function fetchRegisterTypes(): Promise<IRegisterType[]> {
  return apiGet<IRegisterType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/register-types`);
}
